<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Apparato GastroEnterico" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Addome:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoGastroenterico.addome }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoGastroenterico.addome" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Organi Ipocondriaci(fegato e milza):</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoGastroenterico.organiIpocondriaci }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoGastroenterico.organiIpocondriaci" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Alvo:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoGastroenterico.alvo }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoGastroenterico.alvo" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataApparatoGastroenterico: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    addome: "",
                    organiIpocondriaci: "",
                    alvo: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataApparatoGastroenterico: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaApparatoGastroenterico: "/rsaschedarelazionesanitariaapparatogastroenterico",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaApparatoGastroenterico() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaApparatoGastroenterico + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaApparatoGastroentericoSuccess, me.resultResponseSchedaRelazioneSanitariaApparatoGastroentericoError);
        },

        resultResponseSchedaRelazioneSanitariaApparatoGastroentericoSuccess(response) {
            let me = this;
            me.jsonDataApparatoGastroenterico = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaApparatoGastroentericoError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataApparatoGastroenterico = {
                id: null,
                idAccettazione: this.idAccettazione,
                addome: "",
                organiIpocondriaci: "",
                alvo: "",
            };
        },

        onSalvaApparatoGastroenterico() {
            let me = this;
            me.jsonDataApparatoGastroenterico.idAccettazione = me.idAccettazione;
            if (!me.jsonDataApparatoGastroenterico.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaApparatoGastroenterico, me.jsonDataApparatoGastroenterico, me.saveSchedaRelazioneSanitariaApparatoGastroentericoSuccessResponse, me.saveSchedaRelazioneSanitariaApparatoGastroentericoErrorResponse);
        },
        saveSchedaRelazioneSanitariaApparatoGastroentericoSuccessResponse() {},
        saveSchedaRelazioneSanitariaApparatoGastroentericoErrorResponse() {
            console.error("Errore nel salvataggio dell'apparato gastroenterico:");
        },
    },
};
</script>
